import { render, staticRenderFns } from "./RankedOverlay.vue?vue&type=template&id=1d621517&"
import script from "./RankedOverlay.vue?vue&type=script&lang=js&"
export * from "./RankedOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports